import { PoolCard, PoolCardProps } from '@synergy/components-next';
import { ReactElement } from 'react';
import { styled } from '@mui/material';

import { ArticleCardContent } from './article-card-content';
import { ArticleCardHeader } from './article-card-header';
import { useArticleCardContext } from '../article-card';

const StyledPoolCard = styled(PoolCard)(({ theme }) => ({
    minWidth: 'unset',
    maxWidth: 'unset',
    flexDirection: 'row',
    border: 'none',
    borderBottom: `1.5px solid ${theme.palette.grey[200]}`,
    borderRadius: 0,
}));

export const ArticleCardLandscape = (props: PoolCardProps): ReactElement => {
    const { href, onOpen } = useArticleCardContext();

    return (
        <StyledPoolCard {...props} href={href} onClick={onOpen}>
            <ArticleCardHeader />
            <ArticleCardContent />
        </StyledPoolCard>
    );
};
